export default {
  SET_CONVERSATION: (state, conversation) => (state.conversation = conversation),
  SET_ATTACHMENT_URL(state, { key, url }) {
    state.attachmentUrls = {
      ...state.attachmentUrls,
      [key]: url
    }
  },
  DELETE_ATTACHMENT_URL(state, key) {
    const attachmentUrls = { ...state.attachmentUrls }
    delete attachmentUrls[key]
    state.attachmentUrls = attachmentUrls
  },
  CONFIRM_IMAGE_POLICY: state => (state.imagePolicyConfirmed = true),
  OPEN_SUPPORT(state, { eventId = null, eventDescription = '' } = {}) {
    if (state.conversation) {
      state.conversation = {
        ...state.conversation,
        messages: state.conversation.messages.filter(item => !item.temporary)
      }
    }
    state.eventId = eventId
    state.eventDescription = eventDescription
    state.visible = true
    state.conversationVersion += 1
  },
  CLOSE_SUPPORT(state) {
    if (state.conversation) {
      state.conversation = {
        ...state.conversation,
        messages: state.conversation.messages.filter(item => !item.temporary)
      }
    }
    state.visible = false
    state.eventId = null
    state.eventDescription = ''
    state.conversationVersion += 1
  },
  START_NEW_TOPIC(state, conversation) {
    state.conversation = conversation
    state.eventId = null
    state.eventDescription = ''
    state.conversationVersion += 1
  },
  RESET_SUPPORT(state) {
    state.conversation = null
    state.visible = false
    state.eventId = null
    state.eventDescription = ''
    state.imagePolicyConfirmed = false
    state.attachmentUrls = {}
    state.conversationVersion += 1
  }
}
